{
  "id": "sobek",
  "pantheon": "egyptians",
  "name": {
    "pt-BR": "Sobek",
    "en": "Sobek"
  },
  "icon": "gods/sobek",
  "portrait": "gods/sobek-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "petsuchos": 1,
    "roc": 1
  },
  "unlocks": [
    "petsuchos",
    "roc",
    "solar-barque",
    "sun-dried-mud-brick",
    "crocodilopolis",
    "dark-water"
  ],
  "powers": ["locust-swarm"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml, minor_gods.xml, string_table.txt)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "God of kingship and defense. Focus: buildings and camel units. Free unit(s) spawn at a Temple when the age-up completes. God power recharge 150 s."
  }
}
